<template>
  <SSection
    v-for="(item, index) in items"
    :key="index"
    :title="item.title"
    :has-separator="false"
  >
    <template #no-container>
      <SCardsRated :items="item.cottages.items" />
      <TContainer v-if="item.button?.url">
        <UButton
          :ui="mobileFullWidthButton"
          size="md"
          color="neutral"
          variant="subtle"
          :label="item.button.text"
          :to="item.button.url"
          external
          class="mt-7"
        />
      </TContainer>
    </template>
  </SSection>
</template>
<script setup lang="ts">
import type { propsInterface as sCardsRatedProps } from '~~/modules/design-system/sections/s-cards-rated/index.vue'
import { mobileFullWidthButton } from '~~/modules/design-system/utils/nuxt-ui-config/components/button'

type sCardsRatedWrapper = {
  title?: string
  cottages: sCardsRatedProps
  button: {
    text: string
    url: string | null
  } | null
}

export interface propsInterface {
  items: sCardsRatedWrapper[]
}

defineProps<propsInterface>()
</script>
